"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var RoleSwitchModal_component_exports = {};
__export(RoleSwitchModal_component_exports, {
  RoleSwitchModal: () => RoleSwitchModal,
  default: () => RoleSwitchModal_component_default
});
module.exports = __toCommonJS(RoleSwitchModal_component_exports);
var import_react = __toESM(require("react"));
var import_baseTheme = __toESM(require("../../../themes/baseTheme"));
var import_keyBy = __toESM(require("lodash/keyBy"));
var import_react_i18next = require("react-i18next");
var import_useOnKeydown = require("../../../utils/useOnKeydown/useOnKeydown.hook");
var import_Helpers = require("../../../utils/Helpers");
var import_atoms = require("../../atoms");
var import_roles = require("../../../utils/roles");
var import_RolePickerItem = require("../../atoms/RolePickerItem/RolePickerItem.component");
var import_RoleSwitchModal = require("./RoleSwitchModal.styled");
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
var RoleSwitchModal = function RoleSwitchModal2(_ref) {
  var user = _ref.user, _ref$currentRole = _ref.currentRole, currentRole = _ref$currentRole === void 0 ? import_roles.NOT_ROLE_SELECTED : _ref$currentRole, _ref$availableRoles = _ref.availableRoles, availableRoles = _ref$availableRoles === void 0 ? [] : _ref$availableRoles, _ref$appElement = _ref.appElement, appElement = _ref$appElement === void 0 ? "head" : _ref$appElement, _ref$onChangeRole = _ref.onChangeRole, onChangeRole = _ref$onChangeRole === void 0 ? function() {
    return void 0;
  } : _ref$onChangeRole, _ref$mobileView = _ref.mobileView, mobileView = _ref$mobileView === void 0 ? false : _ref$mobileView, _ref$withKebabMenu = _ref.withKebabMenu, withKebabMenu = _ref$withKebabMenu === void 0 ? true : _ref$withKebabMenu;
  var username = "".concat(user.firstName, " ").concat(user.lastName);
  var _getRoleInfo = (0, import_roles.getRoleInfo)(currentRole), currentRoleName = _getRoleInfo.name, currenRoleIcon = _getRoleInfo.icon;
  var _useState = (0, import_react.useState)(false), _useState2 = _slicedToArray(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
  var _useState3 = (0, import_react.useState)(false), _useState4 = _slicedToArray(_useState3, 2), isMobileViewOpen = _useState4[0], setMobileViewOpen = _useState4[1];
  var _useState5 = (0, import_react.useState)("178px"), _useState6 = _slicedToArray(_useState5, 2), contentHeight = _useState6[0], setHeight = _useState6[1];
  var _useState7 = (0, import_react.useState)("406px"), _useState8 = _slicedToArray(_useState7, 2), contentWidth = _useState8[0], setWidth = _useState8[1];
  var _useState9 = (0, import_react.useState)(false), _useState10 = _slicedToArray(_useState9, 2), loading = _useState10[0], setLoading = _useState10[1];
  var _useState11 = (0, import_react.useState)(null), _useState12 = _slicedToArray(_useState11, 2), role = _useState12[0], setRole = _useState12[1];
  var roleSwitcherMobileRef = (0, import_react.useRef)(null);
  var roleSwitcherButtonMobileRef = (0, import_react.useRef)(null);
  var roleSwitcherBackButtonId = "arrowBackRoleSwitcherBtnId";
  var isFirstRender = (0, import_react.useRef)(true);
  var _useTranslation = (0, import_react_i18next.useTranslation)(), t = _useTranslation.t;
  var toggleModal = function toggleModal2() {
    setIsOpen(true);
    if (availableRoles.length === 3 && user.email) {
      setHeight("336px");
    }
  };
  var closeModal = function closeModal2() {
    setIsOpen(false);
    setMobileViewOpen(false);
    setLoading(false);
  };
  var onChangeRoleHandler = function onChangeRoleHandler2(roleSelected) {
    onChangeRole(roleSelected, closeModal);
    setIsOpen(false);
    setMobileViewOpen(false);
    setHeight("178px");
    setWidth("406px");
    setRole(roleSelected);
  };
  (0, import_react.useEffect)(function() {
    if (role) {
      setLoading(true);
    }
  }, [role]);
  (0, import_react.useEffect)(function() {
    setTimeout(function() {
      if (isMobileViewOpen) {
        roleSwitcherMobileRef.current.focus();
      }
    }, 0);
    if (isMobileViewOpen) {
      (0, import_Helpers.trapFocus)(roleSwitcherMobileRef.current);
    }
    if (!isMobileViewOpen && !isFirstRender.current) {
      var _roleSwitcherButtonMo;
      roleSwitcherButtonMobileRef === null || roleSwitcherButtonMobileRef === void 0 || (_roleSwitcherButtonMo = roleSwitcherButtonMobileRef.current) === null || _roleSwitcherButtonMo === void 0 || _roleSwitcherButtonMo.focus();
    }
    isFirstRender.current = false;
  }, [isMobileViewOpen]);
  var setFocusOnRoleSwitcherIcon = function setFocusOnRoleSwitcherIcon2() {
    setTimeout(function() {
      roleSwitcherButtonMobileRef.current.focus();
    }, 10);
  };
  var handleOnEnterPress = function handleOnEnterPress2(event) {
    if (event.key === "Enter" || event.code === "Space") {
      setMobileViewOpen(false);
      setFocusOnRoleSwitcherIcon();
    }
  };
  (0, import_useOnKeydown.useOnKeydown)(roleSwitcherMobileRef, function(keylist, event) {
    var Escape = keylist.Escape, ArrowDown = keylist.ArrowDown, ArrowUp = keylist.ArrowUp;
    var roleSwitcherButtons = roleSwitcherMobileRef.current.querySelectorAll("button[id]");
    var buttonsId = Object.keys((0, import_keyBy.default)(roleSwitcherButtons, "id"));
    var activeItem = document.activeElement;
    var currentPosition = buttonsId.indexOf(activeItem.id);
    var totalRoleSwitcherButtons = roleSwitcherButtons.length - 1;
    event.stopPropagation();
    if (Escape) {
      setMobileViewOpen(false);
      setFocusOnRoleSwitcherIcon();
    }
    if (ArrowDown) {
      var pos = [totalRoleSwitcherButtons, -1].includes(currentPosition) ? 0 : currentPosition + 1;
      if (roleSwitcherButtons[pos]) {
        roleSwitcherButtons[pos].focus();
      }
    }
    if (ArrowUp) {
      var _pos = currentPosition <= 0 ? totalRoleSwitcherButtons : currentPosition - 1;
      if (roleSwitcherButtons[_pos]) {
        roleSwitcherButtons[_pos].focus();
      }
    }
  });
  var geLoadingContent = function geLoadingContent2(roleSelected) {
    var _getRoleInfo2 = (0, import_roles.getRoleInfo)(roleSelected), roleSelectedName = _getRoleInfo2.name, roleSelectedIcon = _getRoleInfo2.icon;
    var iconSize = 27;
    return /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledLoaderWrapper, {
      id: "role-switch-modal-loading-content",
      role: "alert",
      "aria-label": t("dp_core_roleSwitchModal_switchingRole"),
      customWidth: contentWidth,
      customHeight: contentHeight
    }, /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledSquareLoader, null, /* @__PURE__ */ import_react.default.createElement("div", null, " ")), /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledLoaderTitle, {
      "aria-hidden": "true"
    }, t("dp_core_roleSwitchModal_switchingRole")), /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledLoaderRoleWrapper, {
      "aria-hidden": "true"
    }, /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledLoaderRole, null, /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledIcon, {
      icon: currenRoleIcon,
      size: iconSize
    }), /* @__PURE__ */ import_react.default.createElement("p", null, t("dp_core_toCapitalFirstLetter_anyKey", {
      value: t(currentRoleName)
    }))), /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledArrowWrapper, null, /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledIcon, {
      icon: "arrow-front",
      size: iconSize
    })), /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledLoaderRole, null, /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledIcon, {
      icon: roleSelectedIcon,
      size: iconSize
    }), /* @__PURE__ */ import_react.default.createElement("p", null, t("dp_core_toCapitalFirstLetter_anyKey", {
      value: t(roleSelectedName)
    })))));
  };
  var header = /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledHeaderWrapper, null, /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledAvatar, {
    fontSize: "extraLarge",
    size: 54,
    user,
    title: username,
    "aria-hidden": "true"
  }), /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledHeading, {
    weight: "black",
    size: "extraLarge",
    level: 1,
    "aria-label": username
  }, username), user.email && /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledEmail, {
    "aria-level": 2
  }, user.email));
  var content = /* @__PURE__ */ import_react.default.createElement(import_react.default.Fragment, null, /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledModalContentWrapper, {
    id: "role-switch-modal-content"
  }, /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledSwitchRoleTitle, {
    currentRole,
    "aria-hidden": "true"
  }, t("base_constant_currentlyIn")), /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.HeadingRolePickerItem, {
    "aria-label": "".concat(t("base_status_currentlyLoggedInWith", {
      currentRole: t("dp_core_toCapitalFirstLetter_anyKey", {
        value: t(currentRoleName)
      })
    })),
    "aria-level": 2
  }), /* @__PURE__ */ import_react.default.createElement(import_RolePickerItem.RolePickerItem, {
    selected: true,
    role: currentRole,
    "aria-disabled": true
  }), /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledSwitchRoleTitle, {
    "aria-hidden": "true"
  }, t("dp_core_toCapitalFirstLetter_anyKey", {
    value: t("base_action_switchTo")
  })), availableRoles.map(function(availableRole) {
    var _getRoleInfo3 = (0, import_roles.getRoleInfo)(availableRole), name = _getRoleInfo3.name, dataDpAnalyticsId = _getRoleInfo3.dataDpAnalyticsId;
    if (name !== currentRoleName) {
      return /* @__PURE__ */ import_react.default.createElement(import_RolePickerItem.RolePickerItem, {
        key: availableRole,
        selected: false,
        role: availableRole,
        onSelectRole: onChangeRoleHandler,
        "data-testid": "available roles",
        ariaLabel: t("dp_core_roleSwitchModal_switchTo_aria", {
          name: t("dp_core_toCapitalFirstLetter_anyKey", {
            value: t(name)
          })
        }),
        id: availableRole,
        dataDpAnalyticsId
      });
    }
    return true;
  })));
  return /* @__PURE__ */ import_react.default.createElement(import_react.default.Fragment, null, mobileView ? /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledRoleSwitchMobileContainer, null, /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledRoleSwitchButton, {
    align: "left",
    icon: "up-down",
    iconSize: 16,
    variant: "ghost",
    "aria-label": t("base_action_switchRoles"),
    onClick: function onClick() {
      return setMobileViewOpen(true);
    },
    "data-testid": "Switch roles mobile",
    ref: roleSwitcherButtonMobileRef,
    "data-dp-analytics-id": "GlobalElementsAvatarPopupSwitchRolesButton"
  }, t("base_action_switchRoles")), isMobileViewOpen && /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledMobileRoleSwitchPopupContainer, {
    "data-testid": "roleSwitcherMobileContainer",
    tabIndex: 0,
    ref: roleSwitcherMobileRef
  }, /* @__PURE__ */ import_react.default.createElement(import_atoms.Button, {
    icon: "arrow-back",
    "aria-label": t("dp_core_globalAppSwitcher_goBackButton_aria"),
    iconSize: 24,
    onClick: function onClick() {
      return setMobileViewOpen(false);
    },
    "data-testid": "close role switcher",
    id: roleSwitcherBackButtonId,
    onKeyPress: function onKeyPress(event) {
      return handleOnEnterPress(event);
    },
    variant: "empty",
    circle: true,
    size: "40px"
  }), header, content), loading && /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledMobileRoleSwitchPopupContainer, null, geLoadingContent(role))) : /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledRoleSwitchModalContainer, {
    withKebabMenu
  }, /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledRoleSwitchButton, {
    align: "left",
    icon: "up-down",
    iconSize: 16,
    variant: "ghost",
    "aria-label": t("base_action_switchRoles"),
    onClick: function onClick() {
      return toggleModal();
    },
    "data-testid": "Switch roles desktop",
    "data-dp-analytics-id": "GlobalElementsAvatarPopupSwitchRolesButton"
  }, t("base_action_switchRoles")), /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledGlobalModal, {
    hideBars: true,
    visible: isOpen,
    closeModal,
    id: "9",
    appElement,
    customHeader: header,
    maxWidth: "409px",
    maxHeight: "522px",
    contentPadding: import_baseTheme.default.measurements.extraLarge,
    overlayBackground: "rgba(42, 81, 86, 0.6)",
    withKebabMenu
  }, content), /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.StyledGlobalModal, {
    allowClose: false,
    hideBars: true,
    visible: loading,
    closeModal,
    appElement,
    customHeader: true,
    maxWidth: "408px",
    maxHeight: "274px",
    contentPadding: "zero",
    withKebabMenu
  }, geLoadingContent(role))));
};
var RoleSwitchModal_component_default = RoleSwitchModal;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  RoleSwitchModal
});
//# sourceMappingURL=RoleSwitchModal.component.js.map